import React from 'react';
import classNameBind from 'classnames/bind';
import { TextField } from '../../../TextField';
import Popover from '../../../Popover';
import ActionList from '../../../ActionList';
import styles from './FilteredSelectInner.module.css';

const bindClasses = classNameBind.bind(styles);

class FilteredSelectInner extends React.Component {
  componentDidMount() {
    this.props.onOpen();
  }

  render() {
    const {
      groups,
      search,
      onSearch,
      onItemSelected,
      onFocus,
      onBlur,
      dataId,
    } = this.props;

    return (
      <div className={bindClasses('wrapper-ctn')} data-ppuc-id={dataId}>
        <Popover.Section padding="narrow">
          <TextField
            name="search"
            icon="search"
            onChange={onSearch}
            value={search}
            clearable
            onFocus={onFocus}
            onBlur={onBlur}
            dataId={`${dataId}.search`}
          />
        </Popover.Section>
        <Popover.Section fixedHeight>
          <ActionList
            groups={groups.length > 0 ? groups : []}
            onItemSelected={onItemSelected}
            // dataId={`${dataId}.options`} TODO: uncomment in PPUCC-378
          />
        </Popover.Section>
      </div>
    );
  }
}

FilteredSelectInner.defaultProps = {
  dataId: 'FilteredSelectInner',
};

export default FilteredSelectInner;
